<template>
  <div>
    <!-- 配送单-FBA-标识贴标 取消标识 -->
    <el-dialog :title="$t('message.identificationFBA')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="600px" center>
      <div class="content">
        <!-- 变更类型： -->
        <div class="row">
          <div class="label">变更类型：</div>
          <div class="value">
            <el-radio-group v-model="type">
              <el-radio label="1">批量标识</el-radio>
              <el-radio label="2">取消标识</el-radio>
            </el-radio-group>
          </div>
        </div>
        <!-- 请选择商品对应的售卖平台 -->
        <div v-if="type == 1">
          <h6>请选择商品对应的售卖平台</h6>
          <el-checkbox-group v-model="typeSet">
            <el-checkbox :label="item.type" v-for="item in tagList" :key="item.type"></el-checkbox>

          </el-checkbox-group>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 立即调整 -->
        <el-button type="primary" @click="save" v-if="type == 1" class="primary">{{
          $t("message.immediateAdjustment")
        }}</el-button>
        <!-- 立即调整 -->
        <el-button type="primary" @click="deleteFbaSign" v-if="type == 2" class="primary">{{
          $t("message.immediateAdjustment")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    porderSnSet: { type: Array },
  },
  data() {
    return {
      typeSet: [],
      dialogVisible: false,
      tagList: [],
      // 变更类型：
      type: '1',
      //订单详情标签列表
    };
  },
  created() {
    this.orderDetailTagList()
  },
  methods: {
    // 获取订单详情标签列表
    orderDetailTagList() {
      this.$api.clienteleApi.orderDetailTagList({}).then((res) => {
        this.tagList = res.data;
      })
    },
    // 保存
    save() {
      let datas = {
        porderSnSet: this.porderSnSet,
        typeSet: this.typeSet,
      };
      this.$confirm(
        this.$t("message.isMarkingAndLabeling"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi.addFbaSign(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.generalList();
            this.dialogVisible = false
          });
        })
        .catch(() => { });

    },
    //配送单-FBA-删除FBA标识
    deleteFbaSign() {

      let datas = {
        porderSnSet: this.porderSnSet
      };

      this.$confirm(
        this.$t("message.isCancelTheFBAIdentifier"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.porderApi.deleteFbaSign(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.generalList();
            this.dialogVisible = false
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  padding: 0 30px;

  h6 {
    font-size: 18px;
    margin-bottom: 20px;
  }

  .row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid #e4e7ed;

    .label {
      width: 130px;
    }

    .value {
      flex: 1;
    }
  }
}

/deep/ .el-checkbox-group {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px 20px;

  .el-checkbox {
    display: flex;
    align-items: flex-start;
    min-width: 0;
    margin: 0 !important;

    .el-checkbox__label {
      padding-left: 8px;
      line-height: 20px;
      white-space: normal;
      word-break: break-word;
    }
  }
}

/deep/ .el-radio-group {
  display: flex;
  align-items: center;
  gap: 32px;

  .el-radio {
    margin-right: 0;
  }
}
</style>
